import { Constants } from "@eagerdog/constants";
import { IShow } from "@eagerdog/interfaces";
import { IEventRegisterRow } from "../../../services/helper.service.js";

const allLevelOptions = [
  { value: "None",                                                             id: "None" },
  { value: Constants.dog_class_element_level.fh_agility_on_leash,  id: Constants.dog_class_element_level.fh_agility_on_leash },
  { value: Constants.dog_class_element_level.fh_agility_off_leash, id: Constants.dog_class_element_level.fh_agility_off_leash },
];

const allSectionOptions = [
  { value: "None",                                                                    id: "None" },
  { value: Constants.dog_class_section.fh_agility_division_a, id: Constants.dog_class_section.fh_agility_division_a },
  { value: Constants.dog_class_section.fh_agility_division_b, id: Constants.dog_class_section.fh_agility_division_b },
];

/**
 * Herding-style pattern: level dropdown (label = element constant, includes "None" to deselect)
 * + section dropdown (label = "Section"). Both share id = elementConstant so the section
 * dropdown always targets the right element's class via c.id === input.id.
 */
function fhAgilityRow(elementConstant: string, show?: IShow): IEventRegisterRow {
  const configuredEntries = show?.show_elements?.filter(se => se.show_element === elementConstant) ?? [];
  const configuredLevels   = configuredEntries.map(se => se.level).filter(Boolean)   as string[];
  const configuredSections = configuredEntries.map(se => se.section).filter(Boolean) as string[];

  const levelOptions = configuredLevels.length
    ? [{ value: "None", id: "None" }, ...allLevelOptions.filter(o => o.id !== "None" && configuredLevels.includes(o.id))]
    : allLevelOptions;

  const sectionOptions = configuredSections.length
    ? [{ value: "None", id: "None" }, ...allSectionOptions.filter(o => o.id !== "None" && configuredSections.includes(o.id))]
    : allSectionOptions;

  return {
    inputs: [
      {
        id: elementConstant,
        type: "dropdown",
        elementType: "level",
        flex: 3,
        label: elementConstant,
        defaultValue: "None",
        options: levelOptions,
      },
      {
        id: elementConstant,
        type: "dropdown",
        elementType: "section",
        showElement: elementConstant,
        label: "Section",
        defaultValue: "None",
        options: sectionOptions,
      },
    ],
  };
}

export namespace FHAgility {
  export function getForm(show?: IShow): IEventRegisterRow[] {
    return [
      fhAgilityRow(Constants.dog_class_element.fh_agility_jtt,                           show),
      fhAgilityRow(Constants.dog_class_element.fh_agility_standard_no_weaves,            show),
      fhAgilityRow(Constants.dog_class_element.fh_agility_standard_with_weaves,          show),
      fhAgilityRow(Constants.dog_class_element.fh_agility_advanced_standard_with_weaves, show),
      fhAgilityRow(Constants.dog_class_element.fh_agility_advanced_jumpers_no_weaves,    show),
    ];
  }

  export const form: IEventRegisterRow[] = getForm(undefined);
}
